import './App.css';
import { Routes, Route } from 'react-router-dom';
import Navbar from './Component/Navbar';
import Footer from './Component/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import Contact from './Pages/Contact';
import FAQ from './Pages/FAQ';
import PrivacyPolicy from './Component/Privacy/PrivacyPolicy';
import TermsConditions from './Component/termsconditions/TermsConditions';
import ScrollToTop from './Component/ScrollToTop';
import DriverPrivacy from './Component/Privacy/DriverPrivacy';

function App() {
  return (
   <>
   <ScrollToTop/>
   <Navbar/>
   <Routes>
      <Route path='/' element={<Home/>}></Route>
      <Route path='/about' element={<About/>} />
      <Route path='/contact' element={<Contact/>} />
      <Route path='/faq' element={<FAQ/>} />
      <Route path='/privacy' element={<PrivacyPolicy/>} />
      <Route path='/termsconditions' element={<TermsConditions/>} />
      <Route path='/driver-privacy' element={<DriverPrivacy/>} />
   </Routes>
{/*    
//updated code */}


   <Footer/> 
   </>
  );
}

export default App;
